/**
 * Update JSON Object in Local Storage
 * @param {string} key - The localStorage key.
 * @param {Object} updates - The partial object to merge with existing data.
 * @returns {String | null} - Return String or null.
 */
export function AddOrUpdateSessionData(key, updates = {}) {
    const raw = localStorage.getItem(key);
    const currentData = raw ? JSON.parse(raw) : {};

    const mergedData = {
        ...currentData,
        ...updates,
    };

    localStorage.setItem(key, JSON.stringify(mergedData));

    return GetSessionData(key);
}

/**
 * Update JSON Object in Local Storage
 * @param {string} key - The localStorage key.
 * @param {Object | null} updates - The partial object to merge with existing data.
 * @returns {Object | null} - Return Object or null.
 */
export function AddOrUpdateSessionObject(key, updates = {}) {
    const raw = localStorage.getItem(key);
    const currentData = raw ? JSON.parse(raw) : {};

    const mergedData = {
        ...currentData,
        ...updates,
    };

    localStorage.setItem(key, JSON.stringify(mergedData));

    return GetSessionObject(key);
}

/**
 * Update JSON Object in Local Storage
 * @param {string} key - The sessionStorage key.
 * @returns {Object | null} - Return Object or null.
 */
export function GetSessionData(key) {
    return localStorage.getItem(key) ?? null;
}

/**
 * GET JSON Object in Local Storage
 * @param {string} key - The sessionStorage key.
 * @returns {Object | null} - Return Object or null.
 */
export function GetSessionObject(key) {

    const data = localStorage.getItem(key) ?? null;

    return data ? JSON.parse(data) : null;
}

/**
 * DELETE JSON Object in Local Storage
 * @param {string} key - The sessionStorage key.
 */
export function RemoveSessionData(key) {
    localStorage.removeItem(key);
}

/**
 * Update JSON Object in Local Storage
 * @param {string} storageKey - The sessionStorage key.
 * @param {Object} data - The data to update.
 * @param {Object} inputData - The existing data set.
 * @param {(value: Object) => void} setState - The React state setter function.
 */
export function updateSessionData (storageKey, data, inputData, setState) {

    if (!data) return;

    const updatedValues = {
        ...inputData,
        ...data
    }

    AddOrUpdateSessionObject(storageKey, updatedValues);

    setState(updatedValues);
}